var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#3282FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.5C3 4.11929 4.11929 3 5.5 3H10.5C10.7761 3 11 3.22386 11 3.5C11 3.77614 10.7761 4 10.5 4H5.5C4.67157 4 4 4.67157 4 5.5V14.5C4 15.3284 4.67157 16 5.5 16H10C10.2761 16 10.5 16.2239 10.5 16.5C10.5 16.7761 10.2761 17 10 17H5.5C4.11929 17 3 15.8807 3 14.5V5.5ZM7.5 10C7.5 9.72386 7.72386 9.5 8 9.5H15.2929L13.6464 7.85355C13.4512 7.65829 13.4512 7.34171 13.6464 7.14645C13.8417 6.95118 14.1583 6.95118 14.3536 7.14645L16.8536 9.64645C17.0488 9.84171 17.0488 10.1583 16.8536 10.3536L14.3536 12.8536C14.1583 13.0488 13.8417 13.0488 13.6464 12.8536C13.4512 12.6583 13.4512 12.3417 13.6464 12.1464L15.2929 10.5H8C7.72386 10.5 7.5 10.2761 7.5 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.8c0704ceb082d7a65e9a70841da23561.svg";
export { ForwardRef as ReactComponent };